/**
 * Support widget — the values every surface has to agree on.
 *
 * Each of these was previously a literal in two places. Two of them had already drifted
 * apart (the request timeout and the default reveal delay), which is the argument for
 * this file: a constant that means "the same thing everywhere" should not be typed twice.
 */

/**
 * Endpoint path, WITHOUT a leading slash — fe-react's `makeRequest` prepends the API
 * base itself. Use {@link SUPPORT_ENDPOINT_URL} for a plain `fetch`.
 */
export const SUPPORT_ENDPOINT_PATH = "api/public/v3/support/"

/** Root-relative endpoint URL, for surfaces that call `fetch` directly. */
export const SUPPORT_ENDPOINT_URL = `/${SUPPORT_ENDPOINT_PATH}`

/**
 * How long to wait for the availability answer before falling back to closed.
 *
 * 8 s, the more forgiving of the two values in use. The failure mode of
 * waiting too long is a support entry point that appears late; the failure mode of
 * giving up too early is telling a customer we are closed when we are open. The second
 * is worse, so the timeout errs long.
 */
export const SUPPORT_REQUEST_TIMEOUT_MS = 8000

/** Reveal delay used when the payload carries no `widget.timer_seconds`. */
export const SUPPORT_DEFAULT_TIMER_SECONDS = 20

/** Where the out-of-hours contact-form channel points. */
export const SUPPORT_CONTACT_FORM_HREF = "/dashboard-v2/contact-us/"

// Chat provider identifiers, mirroring `CHAT_PROVIDER_*` in douleutaras `main/const.py`.
export const CHAT_PROVIDER_SALESFORCE = "salesforce"
export const CHAT_PROVIDER_SALESFORCE_NEW = "salesforce_new"

/** Versioned so a future breaking change can invalidate old dismissals. */
export const SUPPORT_DISMISS_STORAGE_KEY = "dw-support-widget-dismissed:v1"

/**
 * Prefix for the per-surface, per-session guard that keeps `Support Widget Shown` firing
 * at most once. The surface name is appended.
 */
export const SUPPORT_SHOWN_SESSION_PREFIX = "dw-support-shown:"
